export const leaveApplications = `{ leaveApplications {
        id
        userId
        companyId
        leaveTypeId
        startDate
        endDate
        resumptionDate
        isActive
        status
        statusDescription
        genderId
        branchId
        regionId
        gender
        leaveType
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
        }`;

export const leaveApprovals = `{ leaveApprovals {
        id
        userId
        applicantId
        applicationId
        companyId
        isActive
        status
        statusDescription
        branchId
        regionId
        gender
        leaveType
        startDate
        endDate
        resumptionDate
        firstName
        lastName
        approverFirstName
        approverLastName
        applicantFirstName
        applicantLastName
        approverRole
        approverRoleGroup
        branch
        region
    }
        }`;

export const allDocumentApprovers = `{
    allDocumentApprovers {
        id
        comments
        documentClassName
        documentClassId
        documentTypeName
        name
        createdDate
        documentId
        approverUserId
        documentTypeId
        createdBy
        isFinallyApproved
        companyId
        isActive
        approvedDate
    }
}`;

export const allDocumentTypes = `{
allDocumentsTypes {
        id
        documentTypeName
        documentCategory
        isActive
        createdBy
        createdDate
        updatedBy
        updatedDate
    }

}`;
export const allPolicies = `{  allPolicies {
        id
        companyId
        leaveTypeId
        leaveType
        gender
        acrues
        isActive
        accrualRate
        accrualDate
        canCarryForward
        maxDaysCarryForward
        maxOpenApplications
        createdDate
        createdBy
        updatedDate
        updatedBy
        maxDays
    }
        }`;
export const allPoliciesView = `{
  allPolicyViews {
    id
    companyId
    leaveTypeId
    leaveType
    gender
    acrues
    accrualRate
    maxDaysCarryForward
    canCarryForward
    accrualDate
    maxOpenApplications
    workSaturday
    createdDate
    createdBy
    updatedDate
    updatedBy
    maxDays
    isActive
  }
}`;
export const LeaveApprovers = `{
    leaveApprovers {
        id
        userId
        companyId
        isActive
        status
        statusDescription
       
        branchId
        regionId
      
        leaveType
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
}`;
export const allLeaveTypes = `{
    allLeaveTypes {
        id
        type
      
    }
}`;
export const allRecurringStatus = `{
    allRecurringTypes {
        id
        type
        
    }
}
`;
export const allUsers = `
{
    allUsers {
        id
        firstName
        lastName
        email
        phone
        username
        
    }
}
`;
export const leaveApplicationsByUser = ` {
    leaveApplicationsByUser {
        id
        userId
        companyId
        leaveTypeId
        startDate
        endDate
        resumptionDate
        isActive
        status
        statusDescription
        genderId
        branchId
        regionId
        gender
        leaveType
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
}`;

export const getStructuredLeaveApplications = ` {
    structuredLeaveApplications {
        id
        userId
        companyId
        leaveTypeId
        startDate
        endDate
        resumptionDate
        isActive
        status
        statusDescription
        genderId
        branchId
        regionId
        gender
        leaveType
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
        employeeId
    }
}`;

export const getApprovedStructuredLeaveApplications = ` {
    approvedStructuredLeaveApplications {
        id
        userId
        companyId
        leaveTypeId
        startDate
        endDate
        resumptionDate
        isActive
        status
        statusDescription
        genderId
        branchId
        regionId
        gender
        leaveType
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
        employeeId
    }
}`;

export const AllEmployeesQuery = ` {
    allEmployees {
    id
        countryId
        userId
        deptId
        genderId
        branchId
        bankId
        bankBranchId
        regionId
        companyId
        age
        nokRelationShip
        salaryBandId
        emailAddress
        nokFirstName
        nokLastName
        nokPhone
        jobTitle
        processPayroll
        accountNumber
        kraPin
        surname
        idNo
        dob
        mobileNumber
        nssfNo
        shifNo
        helbNo
        firstName
        lastName
        hireDate
        terminationDate
        baseSalary
        currency
        createdBy
        createdOn
        modifiedBy
        modifiedOn
        isActive
    }
}
`;

export const allEmployeesByColumnValues = `  {
  allEmployeesByColumnValues(employees: { userId: null }) {
    accountNumber
    age
    bankBranchId
    bankId
    baseSalary
    branchId
    companyId
    countryId
    createdBy
    createdOn
    currency
    deptId
    dob
    emailAddress
    firstName
    genderId
    helbNo
    hireDate
    id
    idNo
    jobTitle
    kraPin
    lastName
    mobileNumber
    modifiedBy
    modifiedOn
    nokFirstName
    nokLastName
    nokPhone
    nokRelationShip
    nssfNo
    processPayroll
    regionId
    salaryBandId
    shifNo
    surname
    terminationDate
    userId
  }
}
`;

export const StaffClaimApplications = `{
    staffClaimApplications {
        accountId
    accountName
    amountInBaseCurrency
    applicantFullName
    applicantUsername
    approvedByUsername
    approvedDate
    approverComments
    approverCount
    branch
    branchId
    caseId
    caseRelated
    caseTitle
    company
    companyId
    createdByUsername
    createdDate
    currencyCode
    currencyId
    currencyName
    currentExchangeRate
    declinedReason
    declinerCount
    description
    disbursedByUsername
    disbursedDate
    disbursementAccountType
    disbursementBankAccountId
    disbursementBankAccountName
    employeeId
    id
    isActive
    isDisbursed
    paymentReference
    region
    regionId
    snapshotExchangeRate
    status
    statusText
    title
    totalAmount
    updatedByUsername
    updatedDate
    userId
      
    }
}`;

export const ClaimApplicationsPendingDisbursement = `{
    claimApplicationsPendingDisbursement {
            accountId
    accountName
    amountInBaseCurrency
    applicantFullName
    applicantUsername
    approvedByUsername
    approvedDate
    approverComments
    approverCount
    branch
    branchId
    caseId
    caseRelated
    caseTitle
    company
    companyId
    createdByUsername
    createdDate
    currencyCode
    currencyId
    currencyName
    currentExchangeRate
    declinedReason
    declinerCount
    description
    disbursedByUsername
    disbursedDate
    disbursementAccountType
    disbursementBankAccountId
    disbursementBankAccountName
    employeeId
    id
    isActive
    isDisbursed
    paymentReference
    region
    regionId
    snapshotExchangeRate
    status
    statusText
    title
    totalAmount
    updatedByUsername
    updatedDate
    userId
       
    }
}
`;

export const ApprovedDisbursedClaims = `{
    approvedDisbursedClaims {
            accountId
    accountName
    amountInBaseCurrency
    applicantFullName
    applicantUsername
    approvedByUsername
    approvedDate
    approverComments
    approverCount
    branch
    branchId
    caseId
    caseRelated
    caseTitle
    company
    companyId
    createdByUsername
    createdDate
    currencyCode
    currencyId
    currencyName
    currentExchangeRate
    declinedReason
    declinerCount
    description
    disbursedByUsername
    disbursedDate
    disbursementAccountType
    disbursementBankAccountId
    disbursementBankAccountName
    employeeId
    id
    isActive
    isDisbursed
    paymentReference
    region
    regionId
    snapshotExchangeRate
    status
    statusText
    title
    totalAmount
    updatedByUsername
    updatedDate
    userId
      
    }
}
`;

export const imprestApplications = `{
    imprestApplications {
        id
        userId
        companyId
        disbursementTypeId
        disbursementType
        title
        description
        isActive
        declinerCount
        approverCount
        caseId
        caseRelated
        status
        statusDescription
        branchId
        regionId
        firstName
        lastName
        phoneNumber
        email
        branch
        region
        employeeid
    }
}`;

export const approvedimprestsurrender = `{
    imprestApplications {
        id
        userId
        companyId
        disbursementTypeId
        disbursementType
        title
        description
        isActive
        declinerCount
        approverCount
        caseId
        caseRelated
        status
        statusDescription
        branchId
        regionId
        firstName
        lastName
        phoneNumber
        email
     
        branch
        region
    }
}`;

export const imprestApplicationsByUser = `{
    imprestApplications {
        id
        title
        description
        amount
        status
        statusText
        approverCount
        declinerCount
        declinedReason
        caseRelated
        caseId
        caseTitle
        isPettyCash
        isDisbursed
        isActive
        createdDate
        updatedDate
        approvedDate
        disbursedDate
        currencyId
        currencyCode
        currencyName
        snapshotExchangeRate
        currentExchangeRate
        amountInBaseCurrency
        accountId
        accountName
        disbursementAccountType
        disbursementBankAccountId
        disbursementBankAccountName
        paymentReference
        companyId
        company
        employeeId
        userId
        applicantUsername
        applicantFullName
        regionId
        region
        branchId
        branch
        createdByUsername
        updatedByUsername
        approvedByUsername
        disbursedByUsername
        approverComments
       
    }
}
`;

export const imprestApplicationsPendingDisbursement = `{
    imprestApplicationsPendingDisbursement {
        id
        title
        description
        amount
        status
        statusText
        approverCount
        declinerCount
        declinedReason
        caseRelated
        caseId
        caseTitle
        isPettyCash
        isDisbursed
        isActive
        createdDate
        updatedDate
        approvedDate
        disbursedDate
        currencyId
        currencyCode
        currencyName
        snapshotExchangeRate
        currentExchangeRate
        amountInBaseCurrency
        accountId
        accountName
        disbursementAccountType
        disbursementBankAccountId
        disbursementBankAccountName
        paymentReference
        companyId
        company
        employeeId
        userId
        applicantUsername
        applicantFullName
        regionId
        region
        branchId
        branch
        createdByUsername
        updatedByUsername
        approvedByUsername
        disbursedByUsername
        approverComments
      
    }
}
`;

export const approvedDisbursedImprests = `{
    approvedDisbursedImprests {
        id
        title
        description
        amount
        status
        statusText
        approverCount
        declinerCount
        declinedReason
        caseRelated
        caseId
        caseTitle
        isPettyCash
        isDisbursed
        isActive
        createdDate
        updatedDate
        approvedDate
        disbursedDate
        currencyId
        currencyCode
        currencyName
        snapshotExchangeRate
        currentExchangeRate
        amountInBaseCurrency
        accountId
        accountName
        disbursementAccountType
        disbursementBankAccountId
        disbursementBankAccountName
        paymentReference
        companyId
        company
        employeeId
        userId
        applicantUsername
        applicantFullName
        regionId
        region
        branchId
        branch
        createdByUsername
        updatedByUsername
        approvedByUsername
        disbursedByUsername
        approverComments
        
       
    }
}
`;
export const approvedImprestApplicationsNotSurrendered = `{
    approvedImprestApplicationsNotSurrendered {
        id
        title
        description
        amount
        status
        statusText
        approverCount
        declinerCount
        declinedReason
        caseRelated
        caseId
        caseTitle
        isPettyCash
        isDisbursed
        isActive
        createdDate
        updatedDate
        approvedDate
        disbursedDate
        currencyId
        currencyCode
        currencyName
        snapshotExchangeRate
        currentExchangeRate
        amountInBaseCurrency
        accountId
        accountName
        disbursementAccountType
        disbursementBankAccountId
        disbursementBankAccountName
        paymentReference
        companyId
        company
        employeeId
        userId
        applicantUsername
        applicantFullName
        regionId
        region
        branchId
        branch
        createdByUsername
        updatedByUsername
        approvedByUsername
        disbursedByUsername
        approverComments
        
       
    }
}
`;

export const requisitionApprovers = `{
    requisitionApprovers {
        id
        userId
        companyId
        isActive
        status
        statusDescription
        branchId
        regionId
        leaveType
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
}
`;
export const userFinanceDetails = ` {
    userFinanceDetails {
        id
        userId
        companyId
        bankId
        branchId
        bankBranch
        bank
        accountNumber
        mpesaNumber
    }
}
`;
export const allImprestSurrender = ` {
    allImprestSurrender {
       id
        companyId
        applicationId
        userId
        employeeId
        applicantUsername
        applicantFullName
        regionId
        region
        branchId
        branch
        totalRequested
        totalSpent
        remainingAmount
        refundAmount
        reimbursementAmount
        status
        statusText
        approverCount
        declinerCount
        declinedReason
        approvedDate
        approvedBy
        approverComments
        autoStaffClaim
        submittedDate
        submittedBy
        createdDate
        createdBy
        updatedDate
        updatedBy
        isActive
        description
        imprestTitle
        imprestDescription
        imprestAmount
    }
}
`;

export const allApprovedImprestSurrender = ` {
    allApprovedImprestSurrender {
       id
        companyId
        applicationId
        userId
        employeeId
        applicantUsername
        applicantFullName
        regionId
        region
        branchId
        branch
        totalRequested
        totalSpent
        remainingAmount
        refundAmount
        reimbursementAmount
        status
        statusText
        approverCount
        declinerCount
        declinedReason
        approvedDate
        approvedBy
        approverComments
        autoStaffClaim
        submittedDate
        submittedBy
        createdDate
        createdBy
        updatedDate
        updatedBy
        isActive
        description
        imprestTitle
        imprestDescription
        imprestAmount
    }
}
`;
export const allDisbursementType = `{
    allDisbursementTypes {
        id
        type
        createdDate
        createdBy
        updatedDate
        updatedBy
    }
}`;
export const employeeLeaveBalances = ` {
    employeeLeaveBalances {
        id
        userId
        companyId
        leaveTypeId
        balance
        isActive
        leaveType
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
    }
}
`;

export const allEmployeeLeaveBalances = ` {
    allEmployeeLeaveBalances {
        id
        userId
        companyId
        leaveTypeId
        balance
        isActive
        leaveType
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
    }
}
`;
export const companyCalendarSetups = ` {
    companyCalendarSetups {
        id
        companyId
        recurringTypeId
        recurringType
        holiday
        isActive
        holidayDate
        createdDate
        createdBy
        updatedDate
        updatedBy
    }
}`;
export const allRelievers = `

{
    relievers {
        id
        firstName
        lastName
        email
        phone
        username
        idno
        roleId
        roleName
        isActive
        lastLogin
        loginAttempts
        firstTimeLogin
        changePassword
        hashedPassword
        createdBy
        createdDate
        companyId
        company
        regionId
        region
        branchId
        branch
        titleId
        title
        genderId
        gender
        countryId
        country
        countyId
        county
        roleGroupId
        roleGroup
        departmentId
        department
        employeePaymentTypeId
        employeePaymentType
        updatedBy
        updatedDate
        deactivateBy
        deactivateDate
        approvedBy
        approvedDate
        registrationStatus
        isSupervisor
    }
}`;
export const imprestApllicationForSurrender = ` {
    imprestApplicationsForSurrender {
        id
        userId
        amount
        companyId
        disbursementTypeId
        disbursementType
        title
        description
        isActive
        declinerCount
        approverCount
        caseId
        caseRelated
        status
        statusDescription
        branchId
        regionId
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
}
`;
export const pettyCashApplications = `
 {
    pcApplications {
        id
        userId
        amount
        companyId
        disbursementTypeId
        disbursementType
        title
        description
        isActive
        declinerCount
        approverCount
        caseId
        caseRelated
        status
        statusDescription
        branchId
        regionId
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
}
`;
export const pettyCashApplicationsByUser = `
 {
    pcApplicationsByUser {
        id
        userId
        amount
        companyId
        disbursementTypeId
        disbursementType
        title
        description
        isActive
        declinerCount
        approverCount
        caseId
        caseRelated
        status
        statusDescription
        branchId
        regionId
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
}

`;

export const allTaxStatuses = `
{
 allTaxStatuses {
        id
        statusName
        description
        createdBy
        createdDate
        updatedBy
        updatedDate
    }
}
    `;

export const allPayrollDeductionMethods = `
{
  allPayrollDeductionMethods {
        id
        methodName
        description
        createdBy
        createdDate
        updatedBy
        updatedDate
    }
}
    `;

export const allPracticeGroups = `
{
  allPracticeGroups {
    id
    name
    createdBy
    createdDate
    updatedBy
    updatedDate
  }
}
`;

export const allLevels = `
{
  allLevels {
    id
    name
    createdBy
    createdDate
    updatedBy
    updatedDate
  }
}
`;

export const allSalaryBands = `
{
  allSalaryBands {
    id
    bandName
    createdBy
    createdDate
    updatedBy
    updatedDate
  }
}
`;

export const allRelationshipTypes = `{
    allRelationshipTypes {
        id
        relationshipName
        createdBy
        createdDate
        updatedBy
        updatedDate
    }
}`;
export const allPensionRates = `{
    allPensionRates {
        id
        ratePercentage
        description
        isActive
        createdBy
        createdDate
        updatedBy
        updatedDate
    }
}`;

export const PayComponent = `{
    payComponent {
        id
        companyId
        countryId
        code
        name
        componentType
        isTaxable
        isPensionable
        isStatutory
        isRecurring
        calculationBasis
        defaultRate
        formulaExpression
        statutoryComponentId
        sortOrder
        isActive
        createdBy
        createdAt
        modifiedBy
        modifiedAt
    }
}`;

export const AllStatutoryComponent = `{
    allStatutoryComponent {
        id
        countryId
        code
        name
        calculationType
        basedOn
        employeeContributionType
        employerContributionType
        employeeDefaultRate
        employerDefaultRate
        hasRelief
        reliefType
        isActive
    }
}`;

export const AllStatutoryRate = `{
    allStatutoryRate {
        id
        statutoryComponentId
        lowerBound
        upperBound
        rate
        fixedAmount
        reliefAmount
        reliefType
        effectiveFrom
        effectiveTo
    }
}`;

export const AllEmployeePayComponent = `{
    allEmployeePayComponent {
        id
        employeeId
        payComponentId
        amount
        percentOfBase
        baseComponentCode
        effectiveFrom
        effectiveTo
        isActive
        notes
        createdBy
        createdAt
    }
}`;

export const AllPayrollQuery = ` {
    payrollRun {
        id
        companyId
        countryId
        periodName
        periodStart
        periodEnd
        payDate
        runType
        status
        totalEmployees
        totalGross
        totalNet
        createdBy
        createdAt
        approvedBy
        approvedAt
        isOpen
    }
}
`;
export const AllApprovedPayrollQuery = ` {
    approvedPayrollRun {
        id
        companyId
        countryId
        periodName
        periodStart
        periodEnd
        payDate
        runType
        status
        totalEmployees
        totalGross
        totalNet
        createdBy
        createdAt
        approvedBy
        approvedAt
        isOpen
    }
}
`;

export const AllClosedPostedPayrollQuery = ` {
    closedPostedPayrollRun {
        id
        companyId
        countryId
        periodName
        periodStart
        periodEnd
        payDate
        runType
        status
        totalEmployees
        totalGross
        totalNet
        createdBy
        createdAt
        approvedBy
        approvedAt
        isOpen
    }
}
`;

export const AllPayrollDeductionMethods = `{
    allPayrollDeductionMethods {
        id
        methodName
        description
        createdBy
        createdDate
        updatedBy
        updatedDate
    }
}`;

export const PayrollRun = `{
    payrollRun {
        id
        methodName
        description
        createdBy
        createdDate
        updatedBy
        updatedDate
    }
}`;
export const AllCalculationType = `{
allCalculationType {
        id
        name
    }
}`;
export const AllPayrollBasedOnCalculationType = `{
allPayrollBasedOnCalculationType {
        id
        name
    }
}`;
